import { render, staticRenderFns } from "./BaseDialogNoPadding.vue?vue&type=template&id=e5e0776c&scoped=true&"
import script from "./BaseDialogNoPadding.vue?vue&type=script&lang=js&"
export * from "./BaseDialogNoPadding.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialogNoPadding.vue?vue&type=style&index=0&id=e5e0776c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e0776c",
  null
  
)

export default component.exports